import {InjectionToken} from '@angular/core'

export interface IEnvironment {
  production: boolean //,
  authServiceUrl: string // 'https://spb-common-api.internal.sparbankensyd.se/service',
  dataServiceUrl: string // 'https://ov.internal.sparbankensyd.se/api',
  profitUrl: string // https://lk-test.internal.sparbankensyd.se/api
  // Where the end user opens villkor, villkor.lana.sparbankensyd.se
  villkorHost: string
  domain: string // 'ov.internal.sparbankensyd.se'
  testMode: boolean
}

export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment')
